import React from 'react';

const Collaboration = () => {
  const collabs = [
    {
      title: 'Hospitals & Clinics',
      description: 'Demos, pilots, and training for our platforms.',
    },
    {
      title: 'Researchers & Epidemiologists',
      description: 'Data access, collaborative studies, and publications.',
    },
    {
      title: 'Bioinformaticians',
      description: 'API access, code repos, open-source contributions.',
    },
    {
      title: 'Donors & Partners',
      description: 'Funding and philanthropic collaborations for activities.',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-blue-800">Get Involved</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {collabs.map((collab, index) => (
            <div key={index} className="border border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-all">
              <h3 className="text-xl font-semibold mb-2 text-teal-600">{collab.title}</h3>
              <p className="text-gray-600 mb-4">{collab.description}</p>
              <a href="#contact" className="text-teal-500 hover:underline font-semibold">Contact Us</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Collaboration;